export default "__VITE_ASSET__5adbfb57__"